// Globals
import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';

// Components
import { StyledActionButton, StyledActionsWrap } from '../ProductOfMonthTableActions/ProductOfMonthTableActionsStyles';
import { TrashIcon } from '@/icons';
import { COLORS } from '@/theme';

// Models
import { ITopProduct } from '@/models/products.model';
import { ROUTES } from '@/models/router.model';

type TGetProductsTableColumns = {
  t: TFunction;
  setProductForDelete: (product: ITopProduct) => void;
  canManageTopProduct: boolean;
};

export const useGetProductsOfMonthTableColumns = ({
  t,
  setProductForDelete,
  canManageTopProduct,
}: TGetProductsTableColumns): ColumnsType<ITopProduct> => [
  {
    title: t('products_list_title'),
    dataIndex: 'name',
    key: 'name',
    render: (_, record) => (
      <a href={`${ROUTES.PRODUCTS}/${record.product.id}`} target="_blank" rel="noreferrer">
        {record.product.name}
      </a>
    ),
  },
  {
    title: t('products_list_sku'),
    dataIndex: 'sku',
    key: 'sku',
    render: (_, record) => record.product.sku,
  },
  ...(canManageTopProduct
    ? [
        {
          title: t('products_list_actions'),
          key: 'actions',
          width: '3rem',
          render: (_: unknown, record: ITopProduct) => {
            const handleDelete = () => setProductForDelete(record);

            return (
              <StyledActionsWrap>
                <StyledActionButton $color={COLORS.RED} onClick={handleDelete}>
                  <TrashIcon />
                </StyledActionButton>
              </StyledActionsWrap>
            );
          },
        },
      ]
    : []),
];
